export const ESTIMATED_MONTHLY_VOLUME_OPTIONS = [
  '0-5000',
  '5001-9999',
  '10000-24999',
  '25000-49999',
  '50000-99999',
  '100000-249999',
  '250000',
] as const;

export type EstimatedMonthlyVolume = (typeof ESTIMATED_MONTHLY_VOLUME_OPTIONS)[number];

export const estimatedMonthlyVolumeLabels: Record<EstimatedMonthlyVolume, string> = {
  '0-5000': 'Less than $5,000',
  '5001-9999': '$5,001 - $9,999',
  '10000-24999': '$10,000 - $24,999',
  '25000-49999': '$25,000 - $49,999',
  '50000-99999': '$50,000 - $99,999',
  '100000-249999': '$100,000 - $249,999',
  '250000': '$250,000 and above',
};

export const ESTIMATED_AVERAGE_TICKET_OPTIONS = [
  '0-99',
  '100-249',
  '250-499',
  '500-999',
  '1000',
] as const;

export type EstimatedAverageTicket = (typeof ESTIMATED_AVERAGE_TICKET_OPTIONS)[number];

export const estimatedAverageTicketLabels: Record<EstimatedAverageTicket, string> = {
  '0-99': '$0 - $99',
  '100-249': '$100 - $249',
  '250-499': '$250 - $499',
  '500-999': '$500 - $999',
  '1000': '$1000 and above',
};
